module.exports = __webpack_public_path__ + "assets/img/returnBtn-288f8089.png";